// extracted by mini-css-extract-plugin
export default {"backdrop":"DefaultLayout_backdrop__4LLUM","drawerWrapper":"DefaultLayout_drawerWrapper__huSwa"};